import React, { Dispatch, SetStateAction } from 'react';
import { StyleSheet, View } from 'react-native';
import { AssetFilterSelection } from '../AssetFilterModal/components/AssetFilterItem';
import { Area, Floor, Space } from '../../../../components/Map/SetFloorsModal/FloorItem';
import AssetFilterTag from './components/AssetFilterTag';
import { checkIfFiltersApplied } from '../../Utils';

interface AssetFilterTagsProps {
  selectedFilters: AssetFilterSelection[],
  setSelectedFilters: Dispatch<SetStateAction<AssetFilterSelection[]>>,
  appliedFilters: AssetFilterSelection[],
  applyFilters,
  appliedFloor: Floor,
  setSelectedFloor: Dispatch<SetStateAction<Floor | null>>,
  appliedArea: Area,
  setSelectedArea: Dispatch<SetStateAction<Area | null>>,
  appliedSpace: Space,
  setSelectedSpace: Dispatch<SetStateAction<Space | null>>,
  resetAssetFilter: () => void,
}

const AssetFilterTagSection = ({
  appliedFilters, setSelectedFilters, applyFilters, appliedFloor, setSelectedFloor, appliedArea,
  setSelectedArea, appliedSpace, setSelectedSpace, resetAssetFilter,
}: AssetFilterTagsProps) => {
  const removeFilter = (index: number) => {
    if (appliedFilters.filter((filter: AssetFilterSelection) => filter.value).length <= 1
      && !appliedFloor && !appliedArea && !appliedSpace) {
      resetAssetFilter();
      return;
    }
    const updatedFilters = [...appliedFilters
      .map((filter: AssetFilterSelection) => ({ ...filter }))];
    updatedFilters.splice(index, 1);
    setSelectedFilters(updatedFilters);
    applyFilters(updatedFilters);
  };

  const removeFloorFilter: () => void = () => {
    setSelectedSpace(null);
    setSelectedArea(null);
    setSelectedFloor(null);
    if (!checkIfFiltersApplied(appliedFilters)) resetAssetFilter();
    else applyFilters(appliedFilters, null, null, null);
  };

  const removeAreaFilter: () => void = () => {
    setSelectedSpace(null);
    setSelectedArea(null);
    applyFilters(appliedFilters, appliedFloor, null, null);
  };

  const removeSpaceFilter: () => void = () => {
    setSelectedSpace(null);
    applyFilters(appliedFilters, appliedFloor, appliedArea, null);
  };

  return <View style={styles.container}>
    {appliedFloor && <>
      <AssetFilterTag
        label='Floor'
        value={appliedFloor.Name}
        remove={removeFloorFilter}
      />
      {appliedArea && <>
        <AssetFilterTag
          label='Area'
          value={appliedArea.Name}
          remove={removeAreaFilter}
        />
        {appliedSpace && <AssetFilterTag
          label='Space'
          value={appliedSpace.Name}
          remove={removeSpaceFilter}
        />}
      </>}
    </>}
    {appliedFilters?.map((filter: AssetFilterSelection, index: number) => filter.value
      && <AssetFilterTag
        label={filter.category}
        value={filter.displayValue || filter.value}
        remove={() => removeFilter(index)}
        key={`asset-filter-tag-${filter.category}-${filter.value}`}
      />)}
  </View>;
};

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: 24,
    flexWrap: 'wrap',
  },
});

export default AssetFilterTagSection;
